.fp-interlocutors(data-test='interlocutors')
  .fp-interlocutors--header
    h2.fp-title {{ t('members.conversations') }}
  .fp-interlocutors--empty(v-if='interlocutorsMessages.length === 0' data-test='empty')
    .fp-text.-text-semi-bold {{ t('members.startNewConversation') }}
    .fp-text {{ t('members.conversationsHere') }}
  .fp-interlocutors--list(v-else)
    InterlocutorsListItemVue(v-for='(conversation, index) in interlocutorsMessages' :conversation='conversation'  :key='index' :data-test='`conversation-${index}`')
